import React from 'react';
import { Icon } from './Icon';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';

export const HelpContent = ({ children, id }) => {
  return (
    <button
      className="btn btn-link btn-sm text-medium cursor-help"
      id={`help-section-${id || 'main'}`}
    >
      <UncontrolledPopover
        placement="bottom-start"
        trigger="legacy"
        target={`help-section-${id || 'main'}`}
        strategy="fixed"
      >
        <PopoverBody>{children}</PopoverBody>
      </UncontrolledPopover>
      <Icon name="info" sm className="m-0" />
    </button>
  );
};
